export default __webpack_public_path__ + "static/media/18.65139a96.jpg";